import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "land-subdivision-modal__container" }
const _hoisted_2 = { class: "land-subdivision-modal__header" }
const _hoisted_3 = { class: "land-subdivision-modal__tabs" }
const _hoisted_4 = {
  key: 0,
  class: "land-subdivision-modal__content details-content"
}
const _hoisted_5 = { class: "land-subdivision-modal__details-main" }
const _hoisted_6 = { class: "land-subdivision-modal__details-grid" }
const _hoisted_7 = { class: "land-subdivision-modal__detail-card" }
const _hoisted_8 = { class: "detail-value" }
const _hoisted_9 = { class: "land-subdivision-modal__detail-card" }
const _hoisted_10 = { class: "land-subdivision-modal__detail-card" }
const _hoisted_11 = { class: "detail-value" }
const _hoisted_12 = { class: "land-subdivision-modal__detail-card" }
const _hoisted_13 = { class: "detail-value" }
const _hoisted_14 = { class: "land-subdivision-modal__detail-card" }
const _hoisted_15 = { class: "detail-value" }
const _hoisted_16 = { class: "land-subdivision-modal__detail-card" }
const _hoisted_17 = { class: "detail-value" }
const _hoisted_18 = {
  key: 0,
  class: "land-subdivision-modal__package-notice"
}
const _hoisted_19 = {
  key: 0,
  class: "land-subdivision-modal__lot-preview"
}
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 1,
  class: "land-subdivision-modal__content documents-content"
}
const _hoisted_22 = { class: "land-subdivision-modal__count" }
const _hoisted_23 = { class: "land-subdivision-modal__documents-list" }
const _hoisted_24 = ["onClick", "onKeydown"]
const _hoisted_25 = { class: "document-icon" }
const _hoisted_26 = { class: "document-name" }
const _hoisted_27 = ["aria-label", "onClick"]
const _hoisted_28 = {
  key: 2,
  class: "land-subdivision-modal__content packages-content"
}
const _hoisted_29 = { class: "land-subdivision-modal__package-card" }
const _hoisted_30 = { class: "package-image" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = {
  key: 1,
  class: "package-image-placeholder"
}
const _hoisted_33 = { class: "package-details" }
const _hoisted_34 = { class: "package-heading" }
const _hoisted_35 = { class: "package-title" }
const _hoisted_36 = {
  key: 0,
  class: "package-facade"
}
const _hoisted_37 = {
  key: 0,
  class: "package-builder"
}
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "package-specs" }
const _hoisted_41 = { class: "package-price" }
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = { class: "land-subdivision-modal__package-pagination" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "land-subdivision-modal__footer" }
const _hoisted_47 = {
  key: 1,
  class: "land-subdivision-modal__enquiry"
}
const _hoisted_48 = { class: "enquiry-header" }
const _hoisted_49 = { class: "enquiry-title-row" }
const _hoisted_50 = { class: "enquiry-fields" }
const _hoisted_51 = { class: "enquiry-field" }
const _hoisted_52 = {
  key: 0,
  class: "field-error"
}
const _hoisted_53 = { class: "enquiry-field" }
const _hoisted_54 = {
  key: 0,
  class: "field-error"
}
const _hoisted_55 = { class: "enquiry-field" }
const _hoisted_56 = {
  key: 0,
  class: "field-error"
}
const _hoisted_57 = { class: "enquiry-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "land-subdivision-modal-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        ($props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "land-subdivision-modal",
              onTouchmove: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["self","prevent"]))
            }, [
              _createElementVNode("div", {
                class: "land-subdivision-modal__backdrop",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, null, 32),
              _createElementVNode("div", _hoisted_1, [
                (!$setup.showEnquiryForm)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h2", null, "Lot " + _toDisplayString($setup.lotData.title), 1),
                        _createElementVNode("button", {
                          class: "land-subdivision-modal__close",
                          type: "button",
                          "aria-label": "Close",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                        }, [
                          _createVNode($setup["X"], { size: 24 })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["land-subdivision-modal__tab", { active: $setup.activeTab === 'details' }]),
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.activeTab = 'details'))
                        }, "Lot Details", 2),
                        ($setup.hasDocuments)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["land-subdivision-modal__tab", { active: $setup.activeTab === 'documents' }]),
                              type: "button",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.activeTab = 'documents'))
                            }, "Documents", 2))
                          : _createCommentVNode("", true),
                        ($setup.hasPackages)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: _normalizeClass(["land-subdivision-modal__tab", { active: $setup.activeTab === 'packages' }]),
                              type: "button",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.activeTab = 'packages'))
                            }, "Home & Land Packages", 2))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.activeTab === 'details')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["land-subdivision-modal__details-layout", { 'land-subdivision-modal__details-layout--with-preview': $setup.lotPreview }])
                            }, [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "detail-label" }, "Stage", -1)),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString($setup.stageTitle), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "detail-label" }, "Status", -1)),
                                    _createElementVNode("span", {
                                      class: "detail-value status-badge",
                                      style: _normalizeStyle($setup.getMasterplanStatusBadgeStyle($setup.lotData.status))
                                    }, _toDisplayString($setup.lotStatusLabel), 5)
                                  ]),
                                  _createElementVNode("div", _hoisted_10, [
                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "detail-label" }, "Area", -1)),
                                    _createElementVNode("span", _hoisted_11, _toDisplayString($setup.lotData.size ? `${$setup.lotData.size} m²` : "--"), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "detail-label" }, "Width", -1)),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString($setup.lotData.blockWidth ? `${$setup.lotData.blockWidth} m` : "--"), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "detail-label" }, "Registration", -1)),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString($setup.registrationDate), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "detail-label" }, "Price", -1)),
                                    _createElementVNode("span", _hoisted_17, _toDisplayString($setup.landPrice), 1)
                                  ])
                                ]),
                                ($setup.hasPackages)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode($setup["Home"], { size: 24 }),
                                      _createElementVNode("span", null, _toDisplayString($setup.packageAvailabilityLabel), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              ($setup.lotPreview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("img", {
                                      src: $setup.lotPreview,
                                      alt: `Location of Lot ${$setup.lotData.title} on the masterplan`
                                    }, null, 8, _hoisted_20)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]))
                        : ($setup.activeTab === 'documents')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("p", _hoisted_22, _toDisplayString($setup.documentCountLabel), 1),
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotDocuments, (document) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "land-subdivision-modal__document",
                                    key: document.fileName,
                                    role: "link",
                                    tabindex: "0",
                                    onClick: ($event: any) => ($setup.openDocument(document.link)),
                                    onKeydown: _withKeys(($event: any) => ($setup.openDocument(document.link)), ["enter"])
                                  }, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createVNode($setup["FileText"], { size: 24 })
                                    ]),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString($setup.getDocumentName(document.fileName)), 1),
                                    _createElementVNode("button", {
                                      class: "document-download",
                                      type: "button",
                                      "aria-label": `Download ${$setup.getDocumentName(document.fileName)}`,
                                      onClick: _withModifiers(($event: any) => ($setup.downloadDocument(document)), ["stop"])
                                    }, [
                                      _createVNode($setup["Download"], { size: 22 })
                                    ], 8, _hoisted_27)
                                  ], 40, _hoisted_24))
                                }), 128))
                              ])
                            ]))
                          : ($setup.activeTab === 'packages' && $setup.currentPackage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    ($setup.currentPackageImage)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: $setup.currentPackageImage,
                                          alt: $setup.currentPackage.designName
                                        }, null, 8, _hoisted_31))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createVNode($setup["Home"], { size: 48 })
                                        ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("h3", null, _toDisplayString($setup.currentPackage.designName), 1),
                                        ($setup.currentPackage.facadeName)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString($setup.currentPackage.facadeName), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      ($setup.currentPackage.builderLogoUrl || $setup.currentPackage.builderName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            ($setup.currentPackage.builderLogoUrl)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: $setup.currentPackage.builderLogoUrl,
                                                  alt: `${$setup.currentPackage.builderName || $setup.currentPackage.designName} logo`
                                                }, null, 8, _hoisted_38))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString($setup.currentPackage.builderName), 1))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("p", _hoisted_40, [
                                      ($setup.currentPackage.bedroom)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString($setup.currentPackage.bedroom) + " Bed", 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      ($setup.currentPackage.bathroom)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("· " + _toDisplayString($setup.currentPackage.bathroom) + " Bath", 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      ($setup.currentPackage.living)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createTextVNode("· " + _toDisplayString($setup.currentPackage.living) + " Living", 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      ($setup.currentPackage.cars)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createTextVNode("· " + _toDisplayString($setup.currentPackage.cars) + " Car", 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      ($setup.currentPackage.size)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            _createTextVNode("· " + _toDisplayString($setup.currentPackage.size) + " m²", 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "package-price-label" }, "Package Price", -1)),
                                      _createElementVNode("strong", null, _toDisplayString($setup.packagePrice), 1)
                                    ]),
                                    ($setup.currentPackage.brochureUrl)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "package-brochure",
                                          type: "button",
                                          "aria-label": `Download brochure for ${$setup.currentPackage.designName}`,
                                          onClick: $setup.downloadBrochure
                                        }, [
                                          _createVNode($setup["Download"], { size: 20 }),
                                          _cache[23] || (_cache[23] = _createElementVNode("span", null, "Download Brochure", -1))
                                        ], 8, _hoisted_42))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("button", {
                                    class: "pagination-button",
                                    type: "button",
                                    "aria-label": "Previous package",
                                    disabled: $setup.selectedPackageIndex === 0,
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectedPackageIndex -= 1))
                                  }, [
                                    _createVNode($setup["ChevronLeft"], { size: 28 })
                                  ], 8, _hoisted_44),
                                  _createElementVNode("span", null, _toDisplayString($setup.selectedPackageIndex + 1) + " of " + _toDisplayString($setup.packages.length), 1),
                                  _createElementVNode("button", {
                                    class: "pagination-button",
                                    type: "button",
                                    "aria-label": "Next package",
                                    disabled: $setup.selectedPackageIndex === $setup.packages.length - 1,
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.selectedPackageIndex += 1))
                                  }, [
                                    _createVNode($setup["ChevronRight"], { size: 28 })
                                  ], 8, _hoisted_45)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("button", {
                          class: "make-enquiry-button",
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showEnquiryForm = true))
                        }, "Make Enquiry")
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("button", {
                            class: "enquiry-back",
                            type: "button",
                            "aria-label": "Back to lot details",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.showEnquiryForm = false))
                          }, [
                            _createVNode($setup["ArrowLeft"], { size: 22 })
                          ]),
                          _createElementVNode("div", null, [
                            _cache[24] || (_cache[24] = _createElementVNode("h2", null, "Submit Enquiry", -1)),
                            _createElementVNode("p", null, "Lot " + _toDisplayString($setup.lotData.title), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "land-subdivision-modal__close",
                          type: "button",
                          "aria-label": "Close",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
                        }, [
                          _createVNode($setup["X"], { size: 24 })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", null, [
                            _createTextVNode("Full Name"),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.enquiryForm.fullName) = $event)),
                            placeholder: "Enter your full name",
                            class: _normalizeClass({ error: $setup.enquiryErrors.fullName })
                          }, null, 2), [
                            [_vModelText, $setup.enquiryForm.fullName]
                          ]),
                          ($setup.enquiryErrors.fullName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString($setup.enquiryErrors.fullName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", null, [
                            _createTextVNode("Email"),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.enquiryForm.email) = $event)),
                            type: "email",
                            placeholder: "you@example.com",
                            class: _normalizeClass({ error: $setup.enquiryErrors.email })
                          }, null, 2), [
                            [_vModelText, $setup.enquiryForm.email]
                          ]),
                          ($setup.enquiryErrors.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString($setup.enquiryErrors.email), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _cache[27] || (_cache[27] = _createElementVNode("label", null, [
                            _createTextVNode("Phone"),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.enquiryForm.phone) = $event)),
                            type: "tel",
                            placeholder: "04XX XXX XXX",
                            class: _normalizeClass({ error: $setup.enquiryErrors.phone })
                          }, null, 2), [
                            [_vModelText, $setup.enquiryForm.phone]
                          ]),
                          ($setup.enquiryErrors.phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString($setup.enquiryErrors.phone), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _cache[28] || (_cache[28] = _createElementVNode("label", null, "Message (optional)", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.enquiryForm.message) = $event)),
                            placeholder: "Any questions or comments...",
                            rows: "4"
                          }, null, 512), [
                            [_vModelText, $setup.enquiryForm.message]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "enquiry-footer" }, [
                        _createElementVNode("button", {
                          class: "submit-enquiry-button",
                          type: "button",
                          onClick: $setup.submitEnquiry
                        }, "Submit Enquiry")
                      ])
                    ]))
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}